import React from "react"
import PropTypes from "prop-types"
import {Box} from "@mui/material"
import Content from "../../components/Content"


export const containerColumnPrototype = [
    {
        key: "overflowAuto",
        type: "YESNO",
        label: "Overflow Auto",
        size: 6,
    },
]

const ContainerColumn = ({container}) => {
    const {maxWidth, minHeight, containerSpacing = 24, overflowAuto = false} = container
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: `${containerSpacing}px`,
                maxWidth,
                minHeight,
                width: "100%",
                overflow: overflowAuto ? "auto" : "visible",
            }}>
            {container.children.map(child => (
                <Box
                    key={child.id}
                    sx={child?.flexGrow ? {flexGrow: Number(child.flexGrow)} : undefined}>
                    <Content child={child} />
                </Box>
            ))}
        </Box>
    )
}

ContainerColumn.propTypes = {
    container: PropTypes.object
}

export default ContainerColumn
